import React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import { cn } from "../../lib/utils";

const Checkbox = React.forwardRef(function Checkbox(
  { checked = false, onCheckedChange, className = "", ...props },
  ref
) {
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      checked={checked === true}
      onCheckedChange={(nextValue) => onCheckedChange?.(nextValue === true)}
      className={cn(
        "peer h-4 w-4 shrink-0 rounded-[0.38rem] border border-border bg-background shadow-sm",
        "ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "data-[state=checked]:border-foreground data-[state=checked]:bg-foreground data-[state=checked]:text-background",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className="flex items-center justify-center">
        <Check className="h-3.5 w-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
});

export default Checkbox;
